import React, { ComponentPropsWithoutRef } from 'react';
import FeaturedPost from './FeaturedPost';
import classnames from 'classnames';
import { useGetFeaturedPostsQuery } from '../../../../../../../store/api-slices';
import { useSelector } from 'react-redux';
import { selectFranchiseId } from '../../../../../../../store/slices/InitialDataSlice';

const FeaturedPosts = ({ className, ...rest }: ComponentPropsWithoutRef<'section'>) => {
  const franchiseId = useSelector(selectFranchiseId);
  const { data } = useGetFeaturedPostsQuery(
    {
      franchiseId,
    },
    { skip: !franchiseId },
  );

  if (!data?.length) {
    return;
  }

  return (
    <section className={classnames('space-y-md', className)} {...rest}>
      {data?.map((post) => (
        <FeaturedPost key={post.id} post={post} />
      ))}
    </section>
  );
};

export default FeaturedPosts;
